import React, { Component } from 'react'
import {Carousel} from 'react-bootstrap';
import {sliderData} from '../foodData2'
 class Slider extends Component {

  handleLink(event) {
    let linkName= event.target.value;
    console.log(linkName);
    // let path = `${linkName}`;
    // browserHistory.push(path);
}
    
render() {
 
  let moncarousel = sliderData.map((roll) => {
    
      return (
          
        
          <img className="img-fluid" alt="product" src={ roll.img } key={roll.id} onClick={this.handleLink} value={roll.name} onLoad={() => {window.dispatchEvent(new Event('resize'));}}/>        
        
          );
  });
  return (
    <div>
    <br/>
    <br/>
      <div>
          <section className='carousel-section'>
              <div className='container'>
                  <div className="featured-row">
                      <div className="carousel-block">
                          <h3>   </h3>
                          <div className="carousel-shadow">
                              <Carousel speed={1200} autoplayinterval={7999} autoPlay={true} wraparound="true">
                                  { moncarousel }                                                          
                              </Carousel>
                          </div>
                      </div>
                     
                  </div>
              </div>
          </section>
      </div>
      </div>
    )
  }
}
export default Slider